import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import React, { useState, useRef, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from '@emotion/styled';
import { Information } from '@dfds-ui/icons';
import { Modal } from '@dfds-ui/modal';
import { colorPalette } from '@dfds-ui/colors';
import { HeaderSplitterService } from '../header-splitter.service';


const StyledModal = styled(Modal)`
            z-index: 200;
            button {
                background-color: white;
            }
            `

const StyledInformation = styled(Information)`
    margin-right: 7px;
    color: ${colorPalette.interaction.actionBlue};
    position: relative;
    top: 2px;
    cursor: pointer;`

@Component({
    selector: 'sbw-info-popup',
    template: `
        <span #react></span>
        <template #template>
            <span>
                <ng-content></ng-content>
            </span>
        </template>`
})
export class InfoPopupComponent implements OnInit {

    constructor(private splitter: HeaderSplitterService) { }

    @ViewChild('react', { static: true }) react: ElementRef
    @ViewChild('template', { static: true }) template: ElementRef

    @Input() heading
    @Input() text

    private setOpen: (boolean) => void

    ngOnInit() {
        //we render ng-content to another element outside of react since we cannot use ng-content in react
        //we then move it into react in a hook
        //we save the element here because it will be gone once we do appendChild
        const element = this.template.nativeElement.children[0]
        const hasContent = this.text || element.innerText.match(/\S/) || element.children[0]
        if (!hasContent) return
        const NgContent = () => {
            const target = useRef(null)
            useLayoutEffect(() => { target.current.appendChild(element) })
            return <div ref={target}></div>
        }
        const split = this.splitter.trySplit(this.text, this.heading)
        const InfoPopup = () => {
            const [isOpen, setOpen] = useState(false)
            this.setOpen = setOpen
            return <>
                <StyledInformation onClick={() => setOpen(true)} />
                <StyledModal heading={split.heading} isOpen={isOpen} onRequestClose={() => setOpen(false)}>
                    {this.text && <div dangerouslySetInnerHTML={{ __html: split.rest }}></div>}
                    {!this.text && <NgContent />}
                </StyledModal>
            </>
        }

        ReactDOM.render(<InfoPopup />, this.react.nativeElement)
    }

    open() {
        this.setOpen(true)
    }

}
